var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Model, { attr, hasMany, belongsTo } from '@ember-data/model';
// eslint-disable-next-line ember/use-ember-data-rfc-395-imports

import { computed } from '@ember/object';
export let COMMAND_STATUS = /*#__PURE__*/function (COMMAND_STATUS) {
  COMMAND_STATUS["PENDING"] = "PENDING";
  COMMAND_STATUS["STARTED"] = "STARTED";
  COMMAND_STATUS["SUCCESS"] = "SUCCESS";
  COMMAND_STATUS["ERROR"] = "ERROR";
  COMMAND_STATUS["FAILED"] = "FAILED";
  return COMMAND_STATUS;
}({});
export let COMMAND_PARENT_TYPE = /*#__PURE__*/function (COMMAND_PARENT_TYPE) {
  COMMAND_PARENT_TYPE["CHANNELS"] = "channels";
  COMMAND_PARENT_TYPE["WEBHOOKS_LOGS"] = "webhook_logs";
  COMMAND_PARENT_TYPE["BATCHES"] = "batches";
  COMMAND_PARENT_TYPE["OBJECT_MAPS"] = "object_maps";
  return COMMAND_PARENT_TYPE;
}({});
export let ErrorDescription = /*#__PURE__*/function (ErrorDescription) {
  ErrorDescription["GMB_MISSING_LOCATION_ERROR"] = "GMB_MISSING_LOCATION_ERROR";
  ErrorDescription["GMB_SUSPENDED_LOCATION_ERROR"] = "GMB_SUSPENDED_LOCATION_ERROR";
  return ErrorDescription;
}({});
export let CommandName = /*#__PURE__*/function (CommandName) {
  CommandName["GOOGLE_LOCAL_LISTINGS_SETUP_LOCATION_OBJECT_MAP"] = "GOOGLE_LOCAL_LISTINGS_SETUP_LOCATION_OBJECT_MAP";
  CommandName["GOOGLE_LOCAL_LISTINGS_UPDATE_LOCATION_OBJECT_MAP"] = "GOOGLE_LOCAL_LISTINGS_UPDATE_LOCATION_OBJECT_MAP";
  CommandName["GOOGLE_LOCAL_LISTINGS_SEND_LINK_REQUEST"] = "GOOGLE_LOCAL_LISTINGS_SEND_LINK_REQUEST";
  CommandName["GOOGLE_LOCAL_LISTINGS_VERIFY_LINK_REQUEST"] = "GOOGLE_LOCAL_LISTINGS_VERIFY_LINK_REQUEST";
  CommandName["GOOGLE_LOCAL_LISTINGS_FINISH_SETUP"] = "GOOGLE_LOCAL_LISTINGS_FINISH_SETUP";
  CommandName["GOOGLE_LOCAL_LISTINGS_ONBOARDING"] = "GOOGLE_LOCAL_LISTINGS_ONBOARDING";
  CommandName["GOOGLE_SEND_PHONE_VERIFICATION_REQUEST"] = "GOOGLE_SEND_PHONE_VERIFICATION_REQUEST";
  CommandName["GOOGLE_VERIFY_PHONE_VERIFICATION_REQUEST"] = "GOOGLE_VERIFY_PHONE_VERIFICATION_REQUEST";
  CommandName["GOOGLE_FREE_LISTINGS_FINISH_SETUP"] = "GOOGLE_FREE_LISTINGS_FINISH_SETUP";
  CommandName["GOOGLE_ONBOARDING"] = "GOOGLE_ONBOARDING";
  CommandName["FIND_VALID_MERCHANT_ACCOUNT"] = "FIND_VALID_MERCHANT_ACCOUNT";
  CommandName["RESOLVE_CLAIM_COLLISION"] = "RESOLVE_CLAIM_COLLISION";
  CommandName["GOOGLE_CREATE_MERCHANT_CENTER_ACCOUNT"] = "GOOGLE_CREATE_MERCHANT_CENTER_ACCOUNT";
  CommandName["GOOGLE_SET_MERCHANT_CENTER_ACCOUNT"] = "GOOGLE_SET_MERCHANT_CENTER_ACCOUNT";
  CommandName["GOOGLE_PRECHECK_SETTINGS"] = "GOOGLE_PRECHECK_SETTINGS";
  CommandName["GOOGLE_SET_RETURN_POLICY"] = "GOOGLE_SET_RETURN_POLICY";
  CommandName["GOOGLE_SET_SHIPPING_SETTINGS"] = "GOOGLE_SET_SHIPPING_SETTINGS";
  CommandName["GOOGLE_SET_TAX_SETTINGS"] = "GOOGLE_SET_TAX_SETTINGS";
  CommandName["GOOGLE_DATA_SHARING"] = "GOOGLE_DATA_SHARING";
  CommandName["GOOGLE_SET_WEBSITE_URL"] = "GOOGLE_SET_WEBSITE_URL";
  CommandName["GOOGLE_RETRIEVE_MERCHANT_CENTER_ACCOUNT_LIST"] = "GOOGLE_RETRIEVE_MERCHANT_CENTER_ACCOUNT_LIST";
  CommandName["GOOGLE_LOCAL_LISTINGS_SET_INVENTORY_VERIFICATION_CONTACT"] = "GOOGLE_LOCAL_LISTINGS_SET_INVENTORY_VERIFICATION_CONTACT";
  CommandName["GOOGLE_LOCAL_LISTINGS_REQUEST_INVENTORY_VERIFICATION"] = "GOOGLE_LOCAL_LISTINGS_REQUEST_INVENTORY_VERIFICATION";
  CommandName["GOOGLE_LOCAL_LISTINGS_VERIFY_INVENTORY_VERIFICATION_CONTACT_SET"] = "GOOGLE_LOCAL_LISTINGS_VERIFY_INVENTORY_VERIFICATION_CONTACT_SET";
  CommandName["GOOGLE_PRECHECK_LIA_SETTINGS"] = "GOOGLE_PRECHECK_LIA_SETTINGS";
  CommandName["GOOGLE_ADS_CONSENT_TO_DATA_SHARING"] = "GOOGLE_ADS_CONSENT_TO_DATA_SHARING";
  CommandName["GOOGLE_ADS_RETRIEVE_ADS_ACCOUNT_LIST"] = "GOOGLE_ADS_RETRIEVE_ADS_ACCOUNT_LIST";
  CommandName["GOOGLE_ADS_LINK_ADS_ACCOUNT"] = "GOOGLE_ADS_LINK_ADS_ACCOUNT";
  CommandName["GOOGLE_ADS_CREATE_ADS_ACCOUNT"] = "GOOGLE_ADS_CREATE_ADS_ACCOUNT";
  CommandName["GOOGLE_ADS_FINISH_SETUP"] = "GOOGLE_ADS_FINISH_SETUP";
  CommandName["GOOGLE_ADS_VERIFY_NEW_ADS_ACCOUNT"] = "GOOGLE_ADS_VERIFY_NEW_ADS_ACCOUNT";
  CommandName["CSV_CUSTOM_ATTRIBUTE_IMPORT_COMMAND"] = "CSV_CUSTOM_ATTRIBUTE_IMPORT_COMMAND";
  CommandName["CSV_CUSTOM_ATTRIBUTE_EXPORT_COMMAND"] = "CSV_CUSTOM_ATTRIBUTE_EXPORT_COMMAND";
  CommandName["CSV_LISTING_ENABLE_DISABLE_EXPORT_COMMAND"] = "CSV_LISTING_ENABLE_DISABLE_EXPORT_COMMAND";
  CommandName["CSV_LISTING_ENABLE_DISABLE_IMPORT_COMMAND"] = "CSV_LISTING_ENABLE_DISABLE_IMPORT_COMMAND";
  CommandName["META_COMMERCE_CONSENT_TO_DATA_SHARING"] = "META_COMMERCE_CONSENT_TO_DATA_SHARING";
  CommandName["META_COMMERCE_SET_WEBSITE"] = "META_COMMERCE_SET_WEBSITE";
  CommandName["META_COMMERCE_ONBOARDING"] = "META_COMMERCE_ONBOARDING";
  CommandName["META_COMMERCE_COMPLETE_REAUTH"] = "META_COMMERCE_COMPLETE_REAUTH";
  CommandName["META_COMMERCE_ENABLE_PIXEL"] = "META_COMMERCE_ENABLE_PIXEL";
  CommandName["META_COMMERCE_DISABLE_PIXEL"] = "META_COMMERCE_DISABLE_PIXEL";
  CommandName["META_COMMERCE_PRE_CHECK_ECOM_ELIGIBILITY"] = "META_COMMERCE_PRE_CHECK_ECOM_ELIGIBILITY";
  CommandName["META_COMMERCE_VERIFY_DOMAIN"] = "META_COMMERCE_VERIFY_DOMAIN";
  CommandName["REFRESH_SQUARE_ONLINE_SITES_COMMAND"] = "REFRESH_SQUARE_ONLINE_SITES_COMMAND";
  return CommandName;
}({});
let Command = (_dec = attr('number'), _dec2 = attr('string'), _dec3 = attr('string'), _dec4 = attr('string'), _dec5 = attr('string'), _dec6 = attr('date'), _dec7 = attr('date'), _dec8 = attr('date'), _dec9 = attr('string'), _dec10 = attr('number'), _dec11 = attr('date'), _dec12 = attr('date'), _dec13 = attr('date'), _dec14 = hasMany('channels/command-step'), _dec15 = belongsTo('channels/channel'), _dec16 = computed('status'), _dec17 = computed('status'), _dec18 = computed('status'), _class = class Command extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "parentId", _descriptor, this);
    _initializerDefineProperty(this, "parentType", _descriptor2, this);
    _initializerDefineProperty(this, "merchantId", _descriptor3, this);
    _initializerDefineProperty(this, "name", _descriptor4, this);
    _initializerDefineProperty(this, "status", _descriptor5, this);
    _initializerDefineProperty(this, "processedAt", _descriptor6, this);
    _initializerDefineProperty(this, "startedAt", _descriptor7, this);
    _initializerDefineProperty(this, "lastErroredAt", _descriptor8, this);
    _initializerDefineProperty(this, "errorDescription", _descriptor9, this);
    _initializerDefineProperty(this, "attempted", _descriptor10, this);
    _initializerDefineProperty(this, "createdAt", _descriptor11, this);
    _initializerDefineProperty(this, "updatedAt", _descriptor12, this);
    _initializerDefineProperty(this, "deletedAt", _descriptor13, this);
    _initializerDefineProperty(this, "commandSteps", _descriptor14, this);
    _initializerDefineProperty(this, "channel", _descriptor15, this);
  }
  get isStatusSuccess() {
    return this.status === COMMAND_STATUS.SUCCESS;
  }
  get isStatusFailed() {
    return this.status === COMMAND_STATUS.FAILED;
  }
  get isProcessing() {
    return ![COMMAND_STATUS.SUCCESS, COMMAND_STATUS.FAILED].includes(this.status);
  }
  get hasGmbSuspendedLocationErrors() {
    return this.errorDescription?.includes(ErrorDescription.GMB_SUSPENDED_LOCATION_ERROR) ?? false;
  }
  get hasGmbMissingLocationErrors() {
    return this.errorDescription?.includes(ErrorDescription.GMB_MISSING_LOCATION_ERROR) ?? false;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "parentId", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "parentType", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "merchantId", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "name", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "status", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "processedAt", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "startedAt", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "lastErroredAt", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "errorDescription", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "attempted", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "createdAt", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "updatedAt", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "deletedAt", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "commandSteps", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "channel", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "isStatusSuccess", [_dec16], Object.getOwnPropertyDescriptor(_class.prototype, "isStatusSuccess"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isStatusFailed", [_dec17], Object.getOwnPropertyDescriptor(_class.prototype, "isStatusFailed"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isProcessing", [_dec18], Object.getOwnPropertyDescriptor(_class.prototype, "isProcessing"), _class.prototype), _class);
export { Command as default };